// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__VX8VR","colBig":"styles_colBig__1QN8N","colSmall":"styles_colSmall__lHX6t","shopifyNameWrapper":"styles_shopifyNameWrapper__dS1uV"};